module.exports = __webpack_public_path__ + "static/img/darling-harbour.c70c353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sydney/darling-harbour.jpg
// module id = 277
// module chunks = 1